export enum LocalKey {
  AiCounter = 'ai-counter',
  AiGeneratedInsights = 'aigenerated-insights',
  Auth = 'auth',
  CustomerDashboardRefresh = 'customer-dashboard-refresh',
  DocDraft = 'doc-draft',
  DraftComments = 'draft-comments',
  EmptySections = 'empty-sections',
  ExtractInsights = 'extract-insights',
  Features = 'features',
  FeatureToggler = 'feature-toggler',
  Gamification = 'gamification',
  Groups = 'groups',
  InsightSuggestions = 'insight-suggestions',
  Language = 'language',
  LastInboxBoard = 'last-inbox-board',
  LastInsightBoard = 'last-insight-board',
  LastRoadmapBoard = 'last-roadmap-board',
  LastUsedCustomField = 'last-used-custom-field',
  LastUsedGitHubRepository = 'last-used-github-repository',
  LastView = 'last-view',
  LightOnboarding = 'light-onboarding',
  Linear = 'linear',
  LinearImportDocTypes = 'linear-import-doctypes',
  NewFeatures = 'new-features',
  Onboarding = 'onboarding',
  OnboardingSlack = 'onboarding-slack',
  RequestMakerAccess = 'request-maker-access',
  SectionFilter = 'section-filter',
  Sections = 'sections',
  SidebarCollapsed = 'sidebar-collapsed',
  SidebarWidth = 'sidebar-width',
  SlackNotifBannerHidden = 'slack-notif-banner-hidden',
  StarredViewsCollapsed = 'starred-views-collapsed',
  StatusFilter = 'status-filter',
  Theme = 'theme',
  UserPreferences = 'user-preferences',
  VideoPlaybackRate = 'video-playback-rate',
}
